import { createApp } from 'vue';

// All custom component
import ServiceRequest from '@/views/website/ServiceRequest.vue';
import FactoryEmployee from "@/views/website/client/FactoryEmployee.vue";
import ClientPartner from "@/views/website/client/ClientPartner.vue";
import StudentDashboard from "@/views/website/student/Dashboard.vue";
import StudentProfile from "@/views/website/student/Profile.vue";
import StudentEnrolledCourses from "@/views/website/student/EnrolledCourses.vue";
import StudentPaymentHistory from "@/views/website/student/PaymentHistory.vue";
import StudentPaymentHistoryDetail from "@/views/website/student/PaymentHistoryDetail.vue";
import StudentCourseLearning from "@/views/website/student/CourseLearning.vue";
import StudentAssessment from "@/views/website/student/AssessmentList.vue";
import StudentCertificates from "@/views/website/student/Certificates.vue";
import StudentExamTaking from "@/views/website/student/ExamTaking.vue";
import StudentAssignmentSubmit from "@/views/website/student/AssignmentSubmit.vue";

const components = [
    {el: 'serviceRequest', component: ServiceRequest},
    {el: 'factoryEmployee', component: FactoryEmployee},
    {el: 'clientPartner', component: ClientPartner},
    {el: 'studentDashboardComponent', component: StudentDashboard},
    {el: 'studentProfileComponent', component: StudentProfile},
    {el: 'studentEnrolledCoursesComponent', component: StudentEnrolledCourses},
    {el: 'studentPaymentHistoryComponent', component: StudentPaymentHistory},
    {el: 'studentPaymentHistoryDetailComponent', component: StudentPaymentHistoryDetail},
    {el: 'studentCourseLearningComponent', component: StudentCourseLearning},
    {el: 'studentAssessmentComponent', component: StudentAssessment},
    {el: 'studentCertificatesComponent', component: StudentCertificates},
    {el: 'studentExamTakingComponent', component: StudentExamTaking},
    {el: 'studentAssignmentSubmitComponent', component: StudentAssignmentSubmit},
];

/**
 * Mount each component if its element exists in the DOM
 * This ensures Blade pages with specific divs get the component rendered
 */

export function mountComponents (globalAppPlugins = {}) {
    components.forEach(({el, component}) => {
        const target = document.getElementById(el);
        if (!target) return;

        const useRoute = target?.dataset.useRoute === "true";

        const app = createApp(component);
        // Attach plugins
        if (globalAppPlugins.pinia) app.use(globalAppPlugins.pinia);
        if (globalAppPlugins.router && useRoute) app.use(globalAppPlugins.router);
        if (globalAppPlugins.loadWebsiteGlobalComponents) app.use(globalAppPlugins.loadWebsiteGlobalComponents);
        if (globalAppPlugins.loadThirdParty) app.use(globalAppPlugins.loadThirdParty);
        if (globalAppPlugins.globalCrud) app.use(globalAppPlugins.globalCrud);

        // Attach global functions
        app.config.globalProperties.baseUrl = window.baseUrl;
        app.config.globalProperties.$toast = window.$toast;
        app.config.globalProperties.$swal = window.Swal;

        app.mount(target);
    })
}
